import { Link } from "react-router-dom";

const NavigationMenu = ({ items }) => {
  return (
    <div className="absolute z-10 bg-white child:px-4 child:py-2 flex flex-col border-2 w-[200px] mt-2">
      {items.map((item) => (
        <Link
          key={item.href}
          to={item.href}
          className="hover:bg-logo-second hover:text-white text-black"
        >
          {item.label}
        </Link>
      ))}
    </div>
  );
};

export default NavigationMenu;